<template>
  <div class="bg-image-wrapper d-flex justify-content-around">
    <div class="footer">
      <ul class="nav justify-content-end">
        <li class="nav-item">
          <router-link :to="{ name: 'Impressum' }" class="nav-link link-anime">
            {{
            $t("footer-nav.impressum")
            }}
          </router-link>
          <div class="link-box"></div>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'Policy' }" class="nav-link link-anime">
            {{
            $t("footer-nav.privacy-policy")
            }}
          </router-link>
          <div class="link-box"></div>
        </li>
      </ul>
    </div>
    <cookie-law theme="dark-lime">
      <div slot="message">
        Diese Webseite benutzt Cookies. Durch das Aufrufen dieser Webseite
        akzeptierst du unsere Cookie-Richtlinien.
        <router-link :to="{ name: 'Policy' }" class="nav-link">Mehr Infos</router-link>
      </div>
    </cookie-law>
  </div>
</template>
<script>
import CookieLaw from "vue-cookie-law";
export default {
  components: { CookieLaw },
};
</script>
<style lang="scss">
@import "../style/style.scss";
.Cookie__button {
  background-color: #e9c261;
}
</style>
